import { useState, useEffect } from "react";
import RightSideDetails from "../global/rightSideDetails";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { getTeeTimeValidationMasterAll, postTeeTimeValidationMaster } from "../api/teeTimeAPI"
import moment from "moment";


const TeeTimeValidation = (props) => {

    const [isInit,                  setIsInit]               = useState(true);
    const [rightSideDetails,        setRightSideDetails]     = useState(false);

    const [allMaster,               setAllMaster]            = useState([]);
    const [teeTimeValidationMaster,               setTeeTimeValidationMaster]            = useState({
        Is18Hole: false, Is9Hole: false, Slot18EndTimeValue: '', Slot9EndTimeValue: '', Active: true
    });

    useEffect(() => {
        props.title("Tee Time Validation", "tee-time-validation")       
        fetchTeeTimeValidationMaster();
    }, []);

    useEffect(() => {       
        if (rightSideDetails) {
            Config.Core.OpenDrawer()
            $('.date-input').datepicker({ format: 'dd-mm-yyyy', minDate: new Date()});      
            $('#txtStartDate').on('change', ({target}) => dataHandler('StartDate',  moment(target.value, 'DD-MM-YYYY').format('YYYY-MM-DD')));  
            $('#txtEndDate').on('change', ({target}) => dataHandler('EndDate',  moment(target.value, 'DD-MM-YYYY').format('YYYY-MM-DD')));
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if (rightSideDetails && (teeTimeValidationMaster.Is18Hole || teeTimeValidationMaster.Is9Hole)) {
            if (teeTimeValidationMaster.Is18Hole) {
                $('#txtSlot18').timepicker({
                    minuteStep: 10,
                    defaultTime: teeTimeValidationMaster.Slot18EndTimeValue || ''
                });

                $('#txtSlot18').on('change', ({target}) => dataHandler("Slot18EndTimeValue", target.value));
            }

            if (teeTimeValidationMaster.Is9Hole) {
                $('#txtSlot9').timepicker({
                    minuteStep: 10,
                    defaultTime: teeTimeValidationMaster.Slot9EndTimeValue || ''
                });

                $('#txtSlot9').on('change', ({target}) => dataHandler("Slot9EndTimeValue", target.value));
            }
        }
    }, [rightSideDetails, teeTimeValidationMaster.Is18Hole, teeTimeValidationMaster.Is9Hole]);

    useEffect(() => {       
        if (!isInit) {
            fillDataTable();
        }
    }, [allMaster]);

    const dataHandler = (field,value) => {
        setTeeTimeValidationMaster(d => ({...d, [field]: value}))
    };

    const fetchTeeTimeValidationMaster = async() => {
        try {
            const response = await getTeeTimeValidationMasterAll();
            isInit ? setIsInit(false) : $('#tblMaster').KTDatatable().destroy(); 
            setAllMaster(response); 
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message })
        }
    }

    const checkIfMasterOverlaps = async (allTeeTimeValidationMasters) => {

        const currentStart = moment(teeTimeValidationMaster.StartDate);
        const currentEnd   = moment(teeTimeValidationMaster.EndDate);

        const mastersToCheck = allTeeTimeValidationMasters.filter(master => 
            !teeTimeValidationMaster.ID || master.ID !== teeTimeValidationMaster.ID
        );

        const overlappingMaster = mastersToCheck.find(master => {
            const existingStart = moment(master.StartDate);
            const existingEnd   = moment(master.EndDate);

            const hasDateOverlap = currentStart.isSameOrBefore(existingEnd) && currentEnd.isSameOrAfter(existingStart);

            const isOverlappingMasterActive = master.Active == 1;

            return hasDateOverlap && isOverlappingMasterActive;
        });

        return overlappingMaster;
    };

    const postMaster = async() => {
        const btn  = $('#btnSave');
        const form = $('#addMasterForm');

        form.validate({
            rules: { 
                txtStartDate: { required: true },        
                txtEndDate  : { required: true },
                txtSlot18: { required: function() {
                    return teeTimeValidationMaster.Is18Hole;
                } },
                txtSlot9: { required: function() {
                    return teeTimeValidationMaster.Is9Hole;
                } }
            },
            messages: {
                txtStartDate: { required: "Please select Start Date"},
                txtEndDate  : { required: "Please select End Date"},
                txtSlot18: { required: "Please enter 18 Hole End Time" },
                txtSlot9: { required: "Please enter 9 Hole End Time" }
            }
        });

        if (!form.valid()) return;
        //Validation Goes Here -->

        // Check if validation master is overlapping with any existing masters
        const overlapResult = await checkIfMasterOverlaps(allMaster.allTeeTimeValidationMasters);

        if (!!overlapResult) {
            swal.fire({
                icon: 'error',
                titleText: 'Date Range Conflict',
                text: 'The selected date range overlaps with an existing master',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand'
            });
            return;
        }
                
        helper.StartProcessing(btn);
        try {

            let payload = {}
            if (teeTimeValidationMaster.ID) {
                // Update API payload, removing Created, Updated, 9HoleEndTime and 18HoleEndTime
                const { Created, Updated, '9HoleEndTime': hole9EndTime, '18HoleEndTime': hole18EndTime, ...rest } = teeTimeValidationMaster;
                payload = {
                    ...rest
                };
            } else {
                // add API payload
                payload = {
                    ...teeTimeValidationMaster
                };
            }

            await postTeeTimeValidationMaster(payload);
            
            helper.StopProcessing(btn);
            
            closeDrawer();
            fetchTeeTimeValidationMaster();

            if (teeTimeValidationMaster.ID) {            
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Master updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,                                       
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Master added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    }

    function fillDataTable() {
        const dataTable = $('#tblMaster').KTDatatable({
            data: {
                saveState: false,
                source   : allMaster.allTeeTimeValidationMasters,
                pageSize : 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable  : true,
            pagination: true,
            search    : { input: $('#generalSearch')},
            columns: [               
                {
                    field: 'StartDate',
                    title: 'Start Date',
                    width: 120,
                    template: (row) => moment(row.StartDate).format('DD-MMM-YYYY'),  
                },
                {
                    field: 'EndDate',
                    title: 'End Date', width:120,
                    template: (row) => moment(row.EndDate).format('DD-MMM-YYYY'),                                    
                },
                {
                    field: '18HoleEndTime',
                    title: '18 Hole End Time',
                    template: (row) => {
                        if (row['18HoleEndTime']) {
                            return row['18HoleEndTime'];
                        } else {
                            return '-';
                        }
                    }
                },
                {
                    field: '9HoleEndTime',
                    title: '9 Hole End Time',
                    template: (row) => {
                        if (row['9HoleEndTime']) {
                            return row['9HoleEndTime'];
                        } else {
                            return '-';
                        }
                    }
                },
                {
                    field: 'Created',
                    title: 'Created Date',
                    template: (row) => moment(row.Created).format('DD-MMM-YYYY') 
                },
                {
                    field: 'Active',
                    title: 'Active',
                    template: (row) => {
                        if (row.Active == 1) {
                            return '<span class="kt-badge kt-badge--success kt-badge--pill  padding-lr20 padding-tb10">Yes</span>'
                        } else {
                            return '<span class="kt-badge kt-badge--grey kt-badge--pill padding-lr20 padding-tb10"> No </span>'
                        }
                    }
                }
            ]
        });
    
        dataTable.on('click', 'tr', function () {
            const index = ($("tr").index(this) - 1);
            if (dataTable.dataSet[index]) {
                const rowData = dataTable.dataSet[index];
                const transformedData = {
                    ...rowData,
                    Is18Hole: rowData.Is18Hole ? true : false,
                    Is9Hole: rowData.Is9Hole ? true : false,
                    Active: rowData.Active ? true : false,
                    Slot18EndTimeValue: rowData['18HoleEndTime'],
                    Slot9EndTimeValue: rowData['9HoleEndTime']
                };
                setTeeTimeValidationMaster(transformedData);  
                setRightSideDetails(true);
            } 
        });    
    }

    const closeDrawer = () =>{
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
            setTeeTimeValidationMaster({
                Is18Hole: false, 
                Is9Hole: false, 
                Slot18EndTimeValue: '', 
                Slot9EndTimeValue: '',
                Active: true
            });
        }, 200);
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Master..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button onClick={() => setRightSideDetails(true)} type="button" className="btn btn-brand btn-icon-sm text-white d-inline"><i className="la la-plus"></i> New Master </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblMaster" className="kt-datatable table-striped clickable"></div>
                            {rightSideDetails && <RightSideDetails title="Master Details" onCloseDrawer={() => closeDrawer()}>
                                <div className="kt-portlet">
                                    <div className="kt-portlet__body padding-t30 padding-b0">
                                        <form className="kt-form" id="addMasterForm">
                                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">                                       
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Start Date <span className="red">*</span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div className="input-group date">
                                                            <input 
                                                                id="txtStartDate" 
                                                                name="txtStartDate" 
                                                                type="text" 
                                                                className="form-control date-input" 
                                                                readOnly={true}                                                         
                                                                placeholder="Select date"                                                           
                                                                value={teeTimeValidationMaster.StartDate ? moment(teeTimeValidationMaster.StartDate).format('DD-MM-YYYY') : ''} 
                                                            />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text">
                                                                    <i className="la la-calendar-check-o"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>   
                                                </div>                    
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">End Date <span className="red">*</span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div className="input-group date">
                                                            <input 
                                                                id="txtEndDate" 
                                                                name="txtEndDate" 
                                                                type="text" 
                                                                className="form-control date-input" 
                                                                readOnly={true}                                                         
                                                                placeholder="Select date" 
                                                                value={teeTimeValidationMaster.EndDate ? moment(teeTimeValidationMaster.EndDate).format('DD-MM-YYYY') : ''} 
                                                            />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text">
                                                                    <i className="la la-calendar-check-o"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>   
                                                </div>
                                                {/* 18Hole checkbox */}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">18Hole</label>
                                                    <div className="col-xl-6 col-lg-8 d-flex align-items-center">
                                                        <span className="kt-switch kt-switch--icon">
                                                            <label>
                                                                <input 
                                                                    id="chkIs18Hole" 
                                                                    name="chkIs18Hole" 
                                                                    type="checkbox"
                                                                    checked={teeTimeValidationMaster.Is18Hole} 
                                                                    onChange={(event) => dataHandler('Is18Hole', event.target.checked)} 
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </span>
                                                        {teeTimeValidationMaster.Is18Hole && (
                                                            <>
                                                                <label className="col-form-label col-lg-3">Last Tee</label>
                                                                <div className="input-group timepicker width-120 ml-5">
                                                                    <input id={`txtSlot18`} name="txtSlot18" type="text" readOnly={true} 
                                                                    className="form-control slot-picker" placeholder="Select time" 
                                                                    value={teeTimeValidationMaster.Slot18EndTimeValue || ''}
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text height-38">
                                                                            <i className="la la-clock-o"></i>
                                                                        </span>
                                                                    </div>                           
                                                                </div>
                                                            </>
                                                        )}
                                                    
                                                    </div>
                                                </div>
                                                {/* 9Hole checkbox */}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">9Hole</label>
                                                    <div className="col-xl-6 col-lg-8 d-flex align-items-center">
                                                        <span className="kt-switch kt-switch--icon">
                                                            <label>
                                                                <input 
                                                                    id="chkIs9Hole" 
                                                                    name="chkIs9Hole" 
                                                                    type="checkbox" 
                                                                    checked={teeTimeValidationMaster.Is9Hole}
                                                                    onChange={(event) => dataHandler('Is9Hole', event.target.checked)} 
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </span>
                                                        {teeTimeValidationMaster.Is9Hole && (
                                                            <>
                                                                <label className="col-form-label col-lg-3">Last Tee</label>
                                                                <div className="input-group timepicker width-120 ml-5">
                                                                    <input id={`txtSlot9`} name="txtSlot9" type="text" readOnly={true} 
                                                                    className="form-control slot-picker" placeholder="Select time" 
                                                                    value={teeTimeValidationMaster.Slot9EndTimeValue || ''}
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text height-38">
                                                                            <i className="la la-clock-o"></i>
                                                                        </span>
                                                                    </div>                           
                                                                </div>
                                                            </>
                                                        )}
                                                    
                                                    </div>
                                                </div>
                                                {/* Active checkbox */}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Active</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <span className="kt-switch kt-switch--icon">
                                                            <label>
                                                                <input 
                                                                    id="chkActive" 
                                                                    name="chkActive" 
                                                                    type="checkbox" 
                                                                    checked={teeTimeValidationMaster.Active}
                                                                    onChange={(event) => dataHandler('Active', event.target.checked)} 
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="kt-portlet__foot">
                                                    <div className="kt-form__actions">
                                                        <div className="row">
                                                        <div className="col-lg-9 ml-lg-auto">
                                                            <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={postMaster}> {teeTimeValidationMaster.ID ? 'Update' : 'Save'} </button>
                                                            <button id="btnCancel" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}> Cancel </button>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </RightSideDetails>
                            }
                        </div>
                    </div>
                </div>
            </div>  
        </>
    )
}

export default TeeTimeValidation;